import React, { Component } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../Assets/img/svg/save.svg';
import Cancel from '../../../Assets/img/svg/cancel.svg';
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../Assets/jss/customStyle";
import $ from "jquery"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../helpers/endpointService"
import del from "../../../Assets/img/svg/Del.svg"
import {successAlert,warningAlert} from "../../custom/alert"
import Autocomplete from "react-autocomplete";

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}


class Settings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            menu: true,
            ShipName: "New Ship",
            isEdit: false,
            isAccessControl: false,
            SettingsFormat: {
                "ShipId": 0,
                "Id": 0,
                "TimeZoneId": 0,
                "TimeFormatId": 0,
                "TimeZoneName": "",
                "Convention": "",
                "CreatedBy": "",
                "ModifiedBy": ""
            }
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        // this.state.SettingsFormat.TimeZoneName = "(UTC+05:30) India Standard Time (Kolkata)";
        this.state.ShipName = localStorage.getItem("ShipName");
        localStorage.getItem("UserRoles")?.toLowerCase() == "admin" ? this.state.isAccessControl = false : this.state.isAccessControl = true;
        // this.state.SettingsFormat.TimeZoneId = 417;
        // this.state.SettingsFormat.TimeZoneName = "(UTC+05:30) India Standard Time (Kolkata)"
        // this.setState({})
        this.getSettingsTimeszones();
        this.getSettingsDateFormat();
        this.setState({})
        if (window.location.pathname == '/settings/add') {
            if (localStorage.getItem("addeditid") != null) {
                this.state.SettingsFormat.ShipId = parseInt(localStorage.getItem("addeditid"));
                this.setState({})
                this.getprojectsettingsinfo(localStorage.getItem("addeditid"))
            }
        }
        if (window.location.pathname == '/settings/edit') {
            this.state.SettingsFormat.ShipId = parseInt(localStorage.getItem("DashId"));
            this.setState({})
            this.getprojectsettingsinfo(localStorage.getItem("DashId"))
        }
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getSettingsTimeszones = () => {
        let apiUrl = API.GET_TIMEZONE;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "TIME_VALUES", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    getSettingsDateFormat = () => {
        let apiUrl = API.GET_DATEFORMAT;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "FORMAT_VALUES", data: response.data });

                } else {

                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    getprojectsettingsinfo = (data) => {
        let apiUrl = API.SETTINGS_SHIP + "/id?shipId=" + data;
        // this.props.dispatch({type:"SHOW_LOADER",data:true})
        axios({
            method: "GET",
            url: apiUrl,

        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.SettingsFormat.TimeFormatId = response.data.TimeFormatId;
                    this.state.SettingsFormat.TimeZoneId = response.data.TimeZoneId;
                    this.state.SettingsFormat.TimeZoneName = response.data.TimeZoneName;
                    this.state.SettingsFormat.Convention = response.data.Convention;
                    this.state.timeZoneValue =  response.data.TimeZoneName;
                    // response.data.map((id) => (
                    //     id.TimeZoneName === this.state.SettingsFormat.TimeZoneName ? this.state.SettingsFormat.TimeZoneId = id.TimeZoneId : ""
                    // ))
                    this.setState({})
                    //console.log(this.state.SettingsFormat.TimeZoneId, "sudar")
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                } else {
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#S .MuiListItemText-primary").removeClass("fw-bolder")
        $("#SL").removeClass("active-color")
    }


    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            if (window.location.pathname == '/settings/edit') {
                this.props.navigate("/sidebareditship");
            }
            else {
                this.props.navigate("/sidebaraddship");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (window.location.pathname == '/settings/edit') {
            this.props.navigate("/sidebareditship");
        }
        else {
            this.props.navigate("/sidebaraddship");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Set1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Settings1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Settings").removeClass("d-none");
        $("#Settings").addClass("d-block");
        $("#S .MuiListItemText-primary").addClass("fw-bolder");
        $("#SL").addClass("active-color")
    };

    handleInputChange = (e, node, obj) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.setState({})
        if (node == "TimeZoneId") {
            if (obj.ZoneId == 0) {
                this.state.timeZoneValue = "";
                this.state.SettingsFormat.TimeZoneId = 417;
                this.state.SettingsFormat.TimeZoneName = "(UTC+05:30) India Standard Time (Kolkata)"
                this.setState({})
            }
            else {
                this.state.timeZoneValue = e;
                this.state.SettingsFormat.TimeZoneId = obj.Id;
                this.state.SettingsFormat.TimeZoneName = obj.ZoneName
                this.setState({})
            }
        }
        if (node == "TimeFormatId") {
            this.state.SettingsFormat.TimeFormatId = parseInt(e.target.value);
            this.state.SettingsFormat.Convention = e.target.options[e.target.selectedIndex].text;
            this.setState({})
        }
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/shiplist`)
        }
    }

    Save = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.SaveShipSettings(this.state.SettingsFormat);
    };

    SaveShipSettings = (data) => {
        let apiUrl = API.SETTINGS_SHIP_POST;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
            // headers : {
            //   'content-type': 'application/json'
            // }
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.setState({ cancel: false })
                    successAlert("Data saved successfully.");
                    // dispatch(postSettingsTimeszones(data1))
                    // dispatch({ type: "FORMAT_VALUES", data: response.data });
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                warningAlert("Something went wrong. Please try again.");
                if (error?.response?.status === 401) {

                    // logOut();
                }
            });
    };

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/shiplist`)
    };

    // DeleteItem = () => {
    // }

    renderTimezone = (state, val) => {
        return state?.ZoneName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    render() {
        const { isEdit, isAccessControl } = this.state;
        let { classes, Format, Time, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4 mob-topfixed ">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Set" + "1"} className='textNaviIcon' primary={window.location.pathname == '/settings/edit' ? "Edit Ship" : "New Ship"} />
                                            <NavigateNextIcon id="Set" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5">
                                    <h4 className="pt-1">Settings</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="mt-130 ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75, height: this.state.isMobile ? window.innerHeight - 125 : window.innerHeight - 65 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} disabled={isAccessControl ? true : false} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className="text-center">
                                            <button className={`${classes.button} `} disabled={isAccessControl ? true : false} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Cancel</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td width="95%">
                                                <button className={classes.button} disabled={isAccessControl ? true : false} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} disabled={isAccessControl ? true : false} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table></>}
                    <div  style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">{this.state.ShipName ? this.state.ShipName : "New Ship"}</h6>}
                        <div className={this.state.isMobile ? "row mx-0 mt-1" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "text-right"}>Date Format&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isAccessControl ?
                                        <select className="form-control border-radius form-select view-color" style={{ height: "40px", width: '100%', fontFamily: "Open Sans, sans-serif" }}
                                            disabled
                                            value={this.state.SettingsFormat.TimeFormatId}
                                        >
                                            <option value={0}>Select Date Format</option>
                                            {Format &&
                                                Format.map((i) => {
                                                    return <option value={i.Id}>{i.Convertion}</option>;
                                                })}
                                        </select> :
                                        <select className="form-control border-radius form-select" style={{ height: "40px", width: '100%', fontFamily: "Open Sans, sans-serif" }}
                                            onChange={(e) => { this.handleInputChange(e, "TimeFormatId") }}
                                            value={this.state.SettingsFormat.TimeFormatId}
                                        >
                                            <option value={0}>Select Date Format</option>
                                            {Format &&
                                                Format.map((i) => {
                                                    return <option value={i.Id}>{i.Convertion}</option>;
                                                })}
                                        </select>}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "text-right"}>Time Zone Format&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isAccessControl ?
                                        <select className="form-control border-radius form-select view-color" style={{ height: "40px", width: '100%', fontFamily: "Open Sans, sans-serif" }}
                                            disabled
                                            value={this.state.SettingsFormat.TimeZoneId}
                                        >
                                            <option value={0}>Select Time Format</option>
                                            {Time &&
                                                Time.map((i) => {
                                                    return <option value={i.Id}>{i.ZoneName}</option>;
                                                })}
                                        </select>
                                        :
                                        // <select className="form-control border-radius form-select" style={{ height: "40px", width: '100%', fontFamily: "Open Sans, sans-serif" }}
                                        //     onChange={(e) => { this.handleInputChange(e, "TimeZoneId") }}
                                        //     value={this.state.SettingsFormat.TimeZoneId}
                                        // >
                                        //     <option value={0}>Select Time Format</option>
                                        //     {Time &&
                                        //         Time.map((i) => {
                                        //             return <option value={i.Id}>{i.ZoneName}</option>;
                                        //         })}
                                        // </select>
                                        <div className="autocomplete-wrappers">
                                        <Autocomplete
                                          contentEditable={true}
                                          value={this.state.timeZoneValue}
                                          inputProps={{
                                            placeholder: "Field Inspector Name",
                                          }}
                                          items={this.props.Time ?? []}
                                          getItemValue={(item) => item.ZoneName}
                                          shouldItemRender={this.renderTimezone.bind(
                                            this
                                          )}
                                          renderMenu={(item) => (
                                            <div className="dropdowns d-block">{item}</div>
                                          )}
                                          renderInput={(props) => {
                                            return (
                                              <input
                                                className="form-control border-radius"
                                                id="exampleFormControlInput1"
                                                {...props}
                                                style={{
                                                  height: 32,
                                                  fontSize: 12,
                                                  color: "#000000",
                                                }}
                                              />
                                            );
                                          }}
                                          renderItem={(item, isHighlighted) => (
                                            <div
                                              className={`items 
                                                        ${isHighlighted
                                                  ? "selected-items"
                                                  : ""
                                                }`}
                                            >
                                              {item.ZoneName}
                                            </div>
                                          )}
                                          onChange={(e, newValue) =>{
                                            // this.handleProjectNameSearchChange(e, "Email")
                                            this.setState({
                                                timeZoneValue : e.target.value
                                            })
                                        }
                                          }
                                          onSelect={(e,newValue) =>
                                            // this.handleProjectNameSelectChange(e, "Email")
                                            // this.handleAutocompleteOnchange(e, newValue, "FieldInspectorName")
                                            this.handleInputChange(e, "TimeZoneId", newValue)
                                          }
                                          
                                        />
                                      </div>
                                        }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{ margin: this.state.isMobile ? "auto" : "15px 45px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 ml-2">{this.state.ProjectName}</h6>}
                        <div className="row px-4">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2  mt-3">
                                <label>Date <label style={{ whiteSpace: 'nowrap' }}>Format :</label></label>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4  mt-3">
                                <select className="form-control border-radius form-select" style={{ height: "40px", width: '100%', fontFamily: "Open Sans, sans-serif" }}
                                    onChange={(e) => { this.handleInputChange(e, "TimeFormatId") }}
                                    value={this.state.SettingsFormat.TimeFormatId}
                                >
                                    <option value={0}>Select Date Format</option>
                                    {Format &&
                                        Format.map((i) => {
                                            return <option value={i.Id}>{i.Convertion}</option>;
                                        })}
                                </select>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                                <label>Time Zone <label style={{ whiteSpace: 'nowrap' }}>Format :</label></label>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3">
                                <select className="form-control border-radius form-select" style={{ height: "40px", width: '100%', fontFamily: "Open Sans, sans-serif" }}
                                    onChange={(e) => { this.handleInputChange(e, "TimeZoneId") }}
                                    value={this.state.SettingsFormat.TimeZoneId}
                                >
                                    <option value={0}>Select Time Format</option>
                                    {Time &&
                                        Time.map((i) => {
                                            return <option value={i.Id}>{i.TimeZoneName}</option>;
                                        })}
                                </select>
                            </div>
                        </div>
                    </div> */}
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        Time: state.AddNewShipReducer.Time,
        Format: state.AddNewShipReducer.Format,
    };
}

Settings.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Settings))
);
